import {useAnalytics} from 'lib/use-analytics';
import {PropsWithChildren, useEffect} from 'react';
import {AnalyticsEvent} from 'redux/types/analytics';

type Props = {
    event: AnalyticsEvent;
};

export function Track({event, children}: PropsWithChildren<Props>) {
    const {track} = useAnalytics();

    useEffect(() => {
        track(event);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event]);

    return <>{children}</>;
}
